import {Component, Input, Output, EventEmitter, OnChanges} from '@angular/core';

@Component({
  selector: 'app-progressbar',
  templateUrl: './app-progressbar.component.html',
  styleUrls: ['./app-progressbar.component.scss']
})
export class AppProgressbarComponent implements OnChanges {

  @Input() active: boolean;

  constructor() { }

  ngOnChanges() {}

}
